import React, { Component } from 'react'
import CoverFlow, { EFFECT_TYPES } from '../../CoverFlow'
import logo from '../../../assets/rhomberg-logo.svg'
import AnimatedLogo from '../../Libs/AnimatedLogo'
import { Context } from '../../Context'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import 'react-tabs/style/react-tabs.css'

export default class References extends Component {
    static contextType = Context

    constructor(props) {
        super(props)
    }

    render() {
        return (
            <div className="main">
                <AnimatedLogo image={logo} />
                <h1 className="page-title p-3">Bauservice</h1>
                <div className="container-fluid pos-relative h-100">
                    <Tabs>
                        <div className="slider-height">
                            <TabPanel>
                                <CoverFlow
                                    effect={EFFECT_TYPES.COVERFLOW}
                                    data={this.context.state.constructionServiceProjects}
                                    onItemClick={(item, index) => {
                                        this.props.history.push('/bauservice/referenzen/' + index)
                                    }}
                                />
                            </TabPanel>
                            <TabPanel>
                                <CoverFlow effect={EFFECT_TYPES.COVERFLOW} data={this.context.state.additionsAndConversions} />
                            </TabPanel>
                            <TabPanel>
                                <CoverFlow effect={EFFECT_TYPES.COVERFLOW} data={this.context.state.renovations} />
                            </TabPanel>
                        </div>
                        <TabList>
                            <Tab>Neubauten</Tab>
                            <Tab>Zu- und Umbauten</Tab>
                            <Tab>Gartenmauersanierungen</Tab>
                        </TabList>
                    </Tabs>
                </div>
            </div>
        )
    }
}
